
<mat-card class="vertical-solution-card">
  <mat-card-header>
    <div style="display:flex;justify-content: space-between; width:100%">
      <div><mat-card-title translate>COMMONS.LIST_VERTICAL_SOLUTIONS</mat-card-title></div>
      <div style="margin-top: 0.1rem;"><h6>{{solutionNumbers}} <mat-label translate>COMMONS.RESULTS</mat-label></h6></div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div style="display: flex; justify-content: space-between">
      <div class="inputSearchStyle" style="max-width: 800px">
        <mat-form-field appearance="outline">
          <mat-label translate>COMMONS.SEARCH</mat-label>
          <mat-icon matPrefix [inline]="true">search</mat-icon>
          <input
            matInput
            (keyup)="applyFilterSearch($event)"
            placeholder="{{ 'COMMONS.SEARCH' | translate }}"
            [(ngModel)]="searchSolution"
            #searchText
          />
          <mat-icon matSuffix [inline]="true" (click)="clearUserSearch()" class="pointer">highlight_off</mat-icon>
        </mat-form-field>
      </div>
      <div>
        <button mat-flat-button matTooltipClass="tooltip-layout" (click)="goToNew(true)"  class="button-icon-text" color="primary" style="padding: 0 20px">
          <mat-icon>add</mat-icon>
          <span translate>COMMONS.CREATE</span>
        </button>
      </div>
    </div>

    <div class="table-style" *ngIf="!noItems">
      <table mat-table [dataSource]="dataSourceVerticalSDetails" multiTemplateDataRows matSort>


          <ng-container matColumnDef="signature">
            <th mat-header-cell *matHeaderCellDef ><span translate>COMMONS.SIGNATURE</span></th>
            <td mat-cell *matCellDef="let row">
              {{row.Signature}}
            </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef ><span translate>COMMONS.DESCRIPTION</span></th>
          <td mat-cell *matCellDef="let row">
            {{row.Description}}
          </td>
      </ng-container>
      <ng-container matColumnDef="productCode">
        <th mat-header-cell *matHeaderCellDef ><span translate>COMMONS.PRODUCT_ID</span></th>
        <td mat-cell *matCellDef="let row">
          {{row.ProductCode}}
        </td>
    </ng-container>
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef ><span translate>COMMONS.ACTIVATE</span></th>
        <td mat-cell *matCellDef="let row">
          {{getActiveDescription(row.Active)}}
        </td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef ></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="basic" (click)="goToEdit(row)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"></tr>
      </table>
      <mat-paginator #verticalSolutionsPaginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
    </div>

    <div class="message-box warning" *ngIf="noItems">
      <mat-label translate>COMMONS.NO_ELEMENTFOUND</mat-label>
    </div>
  </mat-card-content>
</mat-card>
<div *ngIf="this.isLoading">
  <tb-loading></tb-loading>
</div>
